import React, { useState } from 'react';
import { Slider } from './ui/slider';

export default function BeforeAfter({ beforeSrc, afterSrc }) {
    const [value, setValue] = useState([50]);

    return (
        <div className="w-full" data-testid="before-after-module">
            <div
                className="relative w-full overflow-hidden rounded-xl border shadow-md aspect-[4/3]"
                aria-label="Before and After comparison"
            >
                <img
                    src={afterSrc}
                    alt="After interior design"
                    className="block w-full h-full object-cover"
                />
                <img
                    src={beforeSrc}
                    alt="Before interior design"
                    style={{ clipPath: `inset(0 ${100 - value[0]}% 0 0)` }}
                    className="pointer-events-none absolute inset-0 w-full h-full object-cover"
                />
                <div
                    className="absolute top-0 bottom-0 w-1 bg-white shadow-lg z-10"
                    style={{ left: `${value[0]}%` }}
                />
            </div>
            <div className="px-2 mt-4">
                <Slider
                    value={value}
                    onValueChange={setValue}
                    min={0}
                    max={100}
                    step={1}
                    aria-label="Reveal before photo"
                    data-testid="before-after-slider"
                />
            </div>
        </div>
    );
}
